import React from 'react'
import { FormattedMessage } from 'react-intl';

class AlertsPlusTemplateSuccess extends React.Component {
    constructor(props) {
        super(props);
        this.timeoutID = null;
    }

    componentDidMount() {
        this.timeoutID = setTimeout(()=>{
            this.closeSuccessWindow();
        },10000)
    }

    componentWillUnmount() {
        if(this.timeoutID){
            clearTimeout(this.timeoutID);
            this.timeoutID = null;
        }
    }

    closeSuccessWindow = () => {
        if(this.timeoutID){
            clearTimeout(this.timeoutID);
            this.timeoutID = null;
        }
        if(this.props.cloudSide){
            if(this.props.closeModal){
                this.props.closeModal("alertsTemplateModal");
            }
        }else{
            window.close();
        }
    }

    render() {
        return(
            <div>
                <FormattedMessage id="ALERT_PLUS_CREATE_EDIT_SUCCESS" values={{methodText: <span>{this.props.methodText}</span>,}}/>
                <p><FormattedMessage id="AUTO_CLOSE_WINDOW" /></p>
                <button onClick={()=>{this.closeSuccessWindow()}}><FormattedMessage id="ALERT_PLUS_CLOSE_WINDOW_BTN" /></button>
            </div>
        )
    }
}

export default AlertsPlusTemplateSuccess;